import { Typography, TypographyProps, useTheme } from '@mui/material';
import Dimens from 'assets/dimens';
import React from 'react';

interface Props extends TypographyProps {
	children: string;
}

const SubTitle: React.FC<Props> = (props) => {
	const theme = useTheme();
	const {
		children, sx,
	} = props;
	return (
		<Typography
			variant="h6"
			{...props}
			sx={{
				fontWeight: Dimens.TEXT_WEIGHT_NORMAL,
				lineHeight: { md: Dimens.TEXT_SUBTITLE, xs: Dimens.TEXT_MEDIUM },
				fontSize: { md: Dimens.TEXT_SUBTITLE, xs: Dimens.TEXT_MEDIUM },
				color: theme.palette.textMain.main,
				...sx,
			}}
		>
			{children}

		</Typography>
	);
};

export default SubTitle;
